import React, { Component } from 'react';
import { Redirect, Link } from 'react-router-dom';
import Select from 'react-select';
import '../Alumnos/AlumnoForm.css';
import '../Alumnos/MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { LookupMesaExamen } from '../MesaExamen/LookupMesaExamen';
import { LookupAlumnoCarrera } from '../AlumnoCarrera/LookupAlumnoCarrera';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';
import { InscripcionExamenErrorMessage } from './InscripcionExamenErrorMessage';

const optionsCuatrimestre = withSelectPlaceholder([
  { value: 'Regular', label: 'Regular' },
  { value: 'Libre', label: 'Libre' },
  { value: 'Equivalencia', label: 'Equivalencia' },
], SELECT_LABELS.condicion);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

export class UpdateInscripcionExamen extends Component {
  static displayName = UpdateInscripcionExamen.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      errorMessage: '',
      redirect: false,
      showLookupAnios: false,
      showLookupCursada: false,
      valueDictado: selectPlaceholder(SELECT_LABELS.condicion),
      cursada: { cursadaCodigo: 0, cursadaMateriaCodigo: '', cursadaMateriaNombre: '', cursadaPeriodo: '' },
      alumno: { alumnocarreraCod: 0, alumnoNombre: '', alumnoCarrera: 0, alumnoCarreraNombre: '' },
      id: this.props.match.params.id,
      details: this.props.match.params.details,
      dictado: '',
      ignorarCorrelatividad: false,
      ignorarRegularidad: false,
      ignorarDosDias: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWInscripcionExamen');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleDictadoChangeInput = (e) => {
    this.clearFeedback();
    this.setState({ dictado: e.value, valueDictado: e });
  };

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/ie/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos de la inscripción.'
        ),
      });
      return;
    }

    const defaultValuePractica = optionsCuatrimestre.filter(
      (x) => x.value.toString().trim() === data.returnModel.inscripcionExamenCondicionInsc.trim()
    );

    this.setState({
      loadingInitial: false,
      dictado: data.returnModel.inscripcionExamenCondicionInsc.trim(),
      cursada: {
        cursadaCodigo: data.returnModel.mesaExamenCod,
        cursadaMateriaCodigo: data.returnModel.mesaExamenCodNavigation.materiaCarreraCod,
        cursadaMateriaNombre: data.returnModel.mesaExamenCodNavigation.materiaCarreraNombre,
        cursadaPeriodo: data.returnModel.mesaExamenCodNavigation.periodoExamenDescripcion.trim() + ' - '
          + data.returnModel.mesaExamenCodNavigation.periodoExamenLlamado.trim() + ' - '
          + data.returnModel.mesaExamenCodNavigation.anioAcademicoDescripcion.trim(),
      },
      alumno: {
        alumnocarreraCod: data.returnModel.alumnoxCarreraCodNavigation.alumnoxCarreraCod,
        alumnoNombre: data.returnModel.alumnoxCarreraCodNavigation.alumnoNombre,
        alumnoCarrera: data.returnModel.alumnoxCarreraCodNavigation.carreraCod,
        alumnoCarreraNombre: data.returnModel.alumnoxCarreraCodNavigation.carreraNombre,
      },
      valueDictado: defaultValuePractica.length > 0
        ? defaultValuePractica[0]
        : selectPlaceholder(SELECT_LABELS.condicion),
    });
  }

  handleShowAniosLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupAnios: true });
    }
  };

  handleShowCursadaLookup = () => {
    if (!this.state.loading) {
      this.setState({ showLookupCursada: true });
    }
  };

  handleHideLookup = () => {
    this.setState({ showLookupAnios: false });
  };

  handleHideLookup1 = () => {
    this.setState({ showLookupCursada: false });
  };

  handleSelectAnioItem = (e) => {
    const anioProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      alumno: {
        alumnocarreraCod: anioProperties[0],
        alumnoNombre: anioProperties[1],
        alumnoCarrera: anioProperties[3],
        alumnoCarreraNombre: anioProperties[2],
      },
      showLookupAnios: false,
    });
  };

  handleSelectCursadaItem = (e) => {
    const carreraProperties = e.split('%');
    this.clearFeedback();
    this.setState({
      showLookupCursada: false,
      materiaCodigo: carreraProperties[6],
      cursada: {
        cursadaCodigo: carreraProperties[0],
        cursadaMateriaCodigo: carreraProperties[6],
        cursadaMateriaNombre: carreraProperties[1].trim(),
        cursadaPeriodo: carreraProperties[2].trim() + ' - ' + carreraProperties[4].trim() + ' - ' + carreraProperties[5].trim() + ' - ' + carreraProperties[3].trim(),
      },
    });
  };

  handleCheckBoxCorrelatividad = (e) => {
    this.clearFeedback();
    this.setState({ ignorarCorrelatividad: e.target.checked });
  };

  handleCheckBoxRegularidad = (e) => {
    this.clearFeedback();
    this.setState({ ignorarRegularidad: e.target.checked });
  };

  handleCheckBoxDosDias = (e) => {
    this.clearFeedback();
    this.setState({ ignorarDosDias: e.target.checked });
  };

  isOkToSave() {
    return this.state.dictado.length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      return;
    }
    if (isSubmitInProgress(this.state.loading)) return;

    if (!this.isOkToSave()) {
      this.setState({ errorMessage: 'Todos los campos son obligatorios' });
      return;
    }

    this.saveStudent();
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) return;

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/ie/update', {
      method: 'POST',
      body: JSON.stringify({
        AlumnoxCarreraCod: this.state.alumno.alumnocarreraCod,
        MesaExamenCod: this.state.cursada.cursadaCodigo,
        InscripcionExamenCod: this.state.id,
        InscripcionExamenCondicionInsc: this.state.dictado,
        MateriaCarreraCod3: this.state.cursada.cursadaMateriaCodigo,
        IgnorarCorrelatividad: this.state.ignorarCorrelatividad,
        IgnorarRegularidad: this.state.ignorarRegularidad,
        IgnorarDosDias: this.state.ignorarDosDias,
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data)) {
      const error = data.errorMessage ? data.errorMessage : 'Forbidden.';
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(data, error),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-ie" />;
    }

    const {
      loadingInitial,
      loading,
      loadError,
      errorMessage,
      alumno,
      cursada,
      dictado,
      valueDictado,
      showLookupAnios,
      showLookupCursada,
      ignorarCorrelatividad,
      ignorarRegularidad,
      ignorarDosDias,
    } = this.state;

    const isBusy = loading;
    const title = this.isReadOnly
      ? 'Ver datos de Inscripción a Examen'
      : 'Modificar datos de Inscripción a Examen';
    const materiaDisplay = cursada.cursadaMateriaNombre.trim() + ' - ' + alumno.alumnoCarreraNombre.trim() + ' - ' + cursada.cursadaPeriodo;
    const alumnoDisplay = alumno.alumnoNombre + ' - ' + alumno.alumnoCarreraNombre;

    if (loadingInitial) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-ie">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <p className="md-form-page__skeleton"><em>Cargando datos...</em></p>
        </div>
      );
    }

    if (loadError) {
      return (
        <div className="md-page md-form-page">
          <Link className="md-form-page__back" to="/md-ie">
            <BackIcon />
            Volver al listado
          </Link>
          <h1 className="md-form-page__title">{title}</h1>
          <div className="md-form-page__error" role="alert">{loadError}</div>
        </div>
      );
    }

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-ie">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">
          {this.isReadOnly
            ? 'Consulta los datos registrados de la inscripción a examen.'
            : 'Actualice el alumno, la mesa o la condición de inscripción.'}
        </p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <InscripcionExamenErrorMessage message={errorMessage} /> : null}
              {loading ? (
                <span className="md-form-page__loading">Actualizando inscripción, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Alumno</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowAniosLookup}
                  disabled={isBusy}
                >
                  Seleccione el Alumno
                </button>
              ) : null}
              {showLookupAnios ? (
                <LookupAlumnoCarrera selectItem={this.handleSelectAnioItem} hideLookup={this.handleHideLookup} />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={alumnoDisplay}
                readOnly
                disabled
                aria-label="Alumno"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Mesa de Examen</span>
              {!this.isReadOnly ? (
                <button
                  type="button"
                  className="md-form-page__pick-btn"
                  onClick={this.handleShowCursadaLookup}
                  disabled={isBusy}
                >
                  Seleccione la Mesa de Examen
                </button>
              ) : null}
              {showLookupCursada ? (
                <LookupMesaExamen
                  carreraCod={alumno.alumnoCarrera}
                  selectItem={this.handleSelectCursadaItem}
                  hideLookup={this.handleHideLookup1}
                />
              ) : null}
              <input
                className="md-form-page__input"
                type="text"
                value={materiaDisplay}
                readOnly
                disabled
                aria-label="Mesa de examen"
              />
            </div>

            <div className="md-form-page__field">
              <span className="md-form-page__label">Condición de Inscripción</span>
              {this.isReadOnly ? (
                <input
                  className="md-form-page__input"
                  type="text"
                  value={dictado}
                  disabled
                  readOnly
                  aria-label="Condición de inscripción"
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="ie-upd-condicion"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valueDictado}
                    options={optionsCuatrimestre}
                    onChange={this.handleDictadoChangeInput}
                    isDisabled={isBusy}
                  />
                </div>
              )}
            </div>

            {!this.isReadOnly ? (
              <>
                <div className="md-form-page__field">
                  <label className="md-form-page__label" htmlFor="ie-upd-ignorar-correlatividad">
                    <input
                      id="ie-upd-ignorar-correlatividad"
                      type="checkbox"
                      checked={ignorarCorrelatividad}
                      onChange={this.handleCheckBoxCorrelatividad}
                      disabled={isBusy}
                    />
                    {' '}Ignorar verificación de correlatividad
                  </label>
                </div>

                <div className="md-form-page__field">
                  <label className="md-form-page__label" htmlFor="ie-upd-ignorar-regularidad">
                    <input
                      id="ie-upd-ignorar-regularidad"
                      type="checkbox"
                      checked={ignorarRegularidad}
                      onChange={this.handleCheckBoxRegularidad}
                      disabled={isBusy}
                    />
                    {' '}Ignorar verificación de regularidad
                  </label>
                </div>

                <div className="md-form-page__field">
                  <label className="md-form-page__label" htmlFor="ie-upd-ignorar-dos-dias">
                    <input
                      id="ie-upd-ignorar-dos-dias"
                      type="checkbox"
                      checked={ignorarDosDias}
                      onChange={this.handleCheckBoxDosDias}
                      disabled={isBusy}
                    />
                    {' '}Ignorar verificación de dos materias por día
                  </label>
                </div>
              </>
            ) : null}

            {!this.isReadOnly ? (
              <div className="md-form-page__actions">
                <button type="submit" className="md-form-page__btn md-form-page__btn--primary" disabled={isBusy}>
                  Confirmar
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
